import { useState } from "react";
import { Grid, TextField } from "../../../../shared/utils/muiImports";
import { ContactDetailsProps } from "../User.type";
import { City, State } from "country-state-city";

import CountrySelector from "../../../../shared/components/CountrySelector";
import StateSelector from "../../../../shared/components/StateSelector";
import { StateList } from "../../../../shared/types/StateSelectorProps";
import { CityList } from "../../../../shared/types/CitySelectorProps";
import { CountryList } from "../../../../shared/types/CountrySelectorProps";
import CitySelector from "../../../../shared/components/CitySelector";

const ContactInformationForm: React.FC<ContactDetailsProps> = ({
  contactDetails,
  onChange,
  errors,
}) => {
  const [selectedCountry] = useState<string | undefined>(
    contactDetails?.country
  );
  const [selectedState] = useState<string | undefined>(contactDetails?.state);

  const [countryIsoCode, setCountryIsoCode] = useState<string | "">("");

  const [stateList, setStateList] = useState<StateList[]>([]);
  const [cityList, setCityList] = useState<CityList[]>([]);

  const handleCountryChange = (country: any) => {
    setCountryIsoCode(country.isoCode);
    const updatedContactDetails = { ...contactDetails, country: country.name };
    onChange({
      target: { name: "contactDetails", value: updatedContactDetails },
    });

    setStateList(
      State.getStatesOfCountry(country.isoCode).map(({ name, isoCode }) => ({
        name,
        isoCode,
      }))
    );
    console.log(stateList);

    console.log("Selected Country:", country);
  };

  const handleStateChange = (state: any) => {
    const updatedContactDetails = { ...contactDetails, state: state.name };
    onChange({
      target: { name: "contactDetails", value: updatedContactDetails },
    });

    setCityList(
      City.getCitiesOfState(countryIsoCode, state.isoCode).map(
        ({ name, stateCode }) => ({
          name,
          stateCode,
        })
      )
    );
  };
  const handleCityChange = (city: any) => {
    const updatedContactDetails = { ...contactDetails, city: city.name };
    onChange({
      target: { name: "contactDetails", value: updatedContactDetails },
    });

    console.log(contactDetails);
  };
  return (
    <>
      <Grid item xs={12} md={3}>
        <TextField
          label="Email"
          name="contactDetails.email"
          fullWidth
          margin="none"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={contactDetails?.email}
          onChange={onChange}
          error={Boolean(errors?.email)}
          helperText={errors?.email}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>Mobile Number *</span>}
          name="contactDetails.mobileNumber"
          fullWidth
          margin="none"
          size="small"
          inputProps={{ maxLength: 10 }}
          InputLabelProps={{ shrink: true }}
          value={contactDetails?.mobileNumber}
          onChange={onChange}
          error={Boolean(errors?.mobileNumber)}
          helperText={errors?.mobileNumber}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Alternate Number"
          name="contactDetails.alternateNumber"
          fullWidth
          margin="none"
          size="small"
          inputProps={{ maxLength: 10 }}
          InputLabelProps={{ shrink: true }}
          onChange={onChange}
          value={contactDetails?.alternateNumber}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          name="contactDetails.address"
          label={<span>Address *</span>}
          fullWidth
          margin="none"
          size="small"
          multiline
          InputLabelProps={{ shrink: true }}
          value={contactDetails?.address}
          onChange={onChange}
          error={Boolean(errors?.address)}
          helperText={errors?.address}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <CountrySelector onCountryChange={handleCountryChange} />
      </Grid>
      <Grid item xs={12} md={3}>
        {selectedCountry && (
          <StateSelector
            stateList={stateList}
            onStateChange={handleStateChange}
          />
        )}
      </Grid>
      <Grid item xs={12} md={3}>
        <CitySelector
          cityList={cityList}
          onCityChange={handleCityChange}
        ></CitySelector>
      </Grid>
    </>
  );
};

export default ContactInformationForm;
